// extracted by mini-css-extract-plugin
module.exports = {"Time":"DateTime_Time__E2mOJ"};